document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.getElementById('anuncio-aov-cart_AnuncioAovCart');
  if (!wrapper) return;
 
  let nivelAnterior = parseInt(wrapper.dataset.nivel, 10) || 0;
  const DURACION_BORDE = 1400; // ms, debe coincidir con la transición de abajo
 
  function setEstado_AnuncioAovCart(estado) {
    wrapper.setAttribute('data-state', estado);
  }
 
  // ---- Trazo del borde (SVG stroke-dashoffset), velocidad constante ----
  function medirYPrepararRect_AnuncioAovCart(box) {
    const rect = box.querySelector('.borde-animado_AnuncioAovCart__rect');
    if (!rect) return null;
 
    const w = box.offsetWidth;
    const h = box.offsetHeight;
    const cs = getComputedStyle(box);
    const strokeW = parseFloat(cs.getPropertyValue('--borde-width')) || 3;
    const radius = parseFloat(cs.borderTopLeftRadius) || 0;
    const inset = strokeW / 2;
 
    rect.setAttribute('x', inset);
    rect.setAttribute('y', inset);
    rect.setAttribute('width', Math.max(w - strokeW, 0));
    rect.setAttribute('height', Math.max(h - strokeW, 0));
    rect.setAttribute('rx', Math.max(radius - inset, 0));
 
    return rect;
  }
 
  function rellenarBorde_AnuncioAovCart(box, callback) {
    const rect = medirYPrepararRect_AnuncioAovCart(box);
    if (!rect) { callback && callback(); return; }
 
    const length = rect.getTotalLength();
    rect.style.transition = 'none';
    rect.style.strokeDasharray = length;
    rect.style.strokeDashoffset = length;
    rect.getBoundingClientRect(); // fuerza reflow
 
    requestAnimationFrame(() => {
      rect.style.transition = `stroke-dashoffset ${DURACION_BORDE}ms linear`;
      rect.style.strokeDashoffset = 0;
    });
 
    setTimeout(() => callback && callback(), DURACION_BORDE + 50);
  }
 
  function desrellenarBorde_AnuncioAovCart(box, callback) {
    const rect = medirYPrepararRect_AnuncioAovCart(box);
    if (!rect) { callback && callback(); return; }
 
    const length = rect.getTotalLength();
    const inicio = performance.now();
 
    function frame_AnuncioAovCart(ahora) {
      const q = Math.min((ahora - inicio) / DURACION_BORDE, 1); // 0 → 1
      const borrado = length * q;
      const visible = length - borrado;
 
      rect.style.transition = 'none';
      rect.style.strokeDasharray = `0 ${borrado} ${visible} 0`;
      rect.style.strokeDashoffset = 0;
 
      if (q < 1) {
        requestAnimationFrame(frame_AnuncioAovCart);
      } else {
        callback && callback();
      }
    }
 
    requestAnimationFrame(frame_AnuncioAovCart);
  }
 
  // ---- Dibujar el borde ya completo si la página carga directamente en
  // estado-4 (el cliente entra a la web/carrito con el descuento máximo ya
  // conseguido de antes: no hay ningún cruce en vivo que detectar, así que
  // sin esto el <rect> se queda sin dimensiones y no se ve nada). ----
  function dibujarBordeCompletoSinAnimar_AnuncioAovCart(box) {
    const rect = medirYPrepararRect_AnuncioAovCart(box);
    if (!rect) return;
    rect.style.transition = 'none';
    rect.style.strokeDasharray = rect.getTotalLength();
    rect.style.strokeDashoffset = 0;
  }
 
  if (wrapper.getAttribute('data-state') === 'estado-4') {
    dibujarBordeCompletoSinAnimar_AnuncioAovCart(wrapper.querySelector('.contenedor-status4-AnuncioAovCart'));
  }
 
  window.addEventListener('resize', () => {
    if (wrapper.getAttribute('data-state') === 'estado-4') {
      dibujarBordeCompletoSinAnimar_AnuncioAovCart(wrapper.querySelector('.contenedor-status4-AnuncioAovCart'));
    }
  });
 
  // ---- Transición suave entre tarjetas de estado (solo fundido) ----
  function transicionSuaveEstado_AnuncioAovCart(boxSaliente, boxEntrante, callback) {
    const DURACION_TRANSICION = 260;
 
    boxSaliente.style.transition = `opacity ${DURACION_TRANSICION}ms ease`;
    boxSaliente.style.opacity = '0';
 
    setTimeout(() => {
      callback(); // aquí se cambia data-state (oculta la saliente, muestra la entrante)
 
      // dejamos la saliente lista para la próxima vez que se use
      boxSaliente.style.transition = 'none';
      boxSaliente.style.opacity = '';
 
      // preparamos la entrante en su posición de "antes de aparecer"
      boxEntrante.style.transition = 'none';
      boxEntrante.style.opacity = '0';
      boxEntrante.getBoundingClientRect(); // fuerza reflow
 
      requestAnimationFrame(() => {
        boxEntrante.style.transition = `opacity ${DURACION_TRANSICION}ms ease`;
        boxEntrante.style.opacity = '1';
      });
    }, DURACION_TRANSICION);
  }
 
  // ---- Máquina de estados ----
  function irAEstado1_AnuncioAovCart() { setEstado_AnuncioAovCart('estado-1'); }
  function irAEstado3_AnuncioAovCart() { setEstado_AnuncioAovCart('estado-3'); }
 
  function irAEstado2yLuegoEstado3_AnuncioAovCart() {
    setEstado_AnuncioAovCart('estado-2');
    const box2 = wrapper.querySelector('.contenedor-status2-AnuncioAovCart');
    rellenarBorde_AnuncioAovCart(box2, () => {
      desrellenarBorde_AnuncioAovCart(box2, () => {
        const box3 = wrapper.querySelector('.contenedor-status3-AnuncioAovCart');
        transicionSuaveEstado_AnuncioAovCart(box2, box3, irAEstado3_AnuncioAovCart);
      });
    });
  }
 
  function irAEstado4_AnuncioAovCart() {
    setEstado_AnuncioAovCart('estado-4');
    const box4 = wrapper.querySelector('.contenedor-status4-AnuncioAovCart');
    rellenarBorde_AnuncioAovCart(box4, () => {
      // se queda en estado-4 con el borde relleno
    });
  }
 
  function salirDeEstado4HaciaEstado3_AnuncioAovCart() {
    const box4 = wrapper.querySelector('.contenedor-status4-AnuncioAovCart');
    desrellenarBorde_AnuncioAovCart(box4, () => {
      irAEstado3_AnuncioAovCart();
    });
  }
 
  function aplicarTransicion_AnuncioAovCart(nuevoNivel) {
    if (nuevoNivel === nivelAnterior) {
      nivelAnterior = nuevoNivel;
      // El wrapper acaba de reemplazarse entero por el HTML fresco del
      // fetch (para refrescar precios/porcentajes), así que el <rect> del
      // borde vuelve a estar "en blanco". Si seguimos en estado-4 (se
      // sigue comprando por encima del objetivo final), hay que repintarlo
      // ya completo, porque aquí no hay ningún cambio de nivel que lo haga.
      if (wrapper.getAttribute('data-state') === 'estado-4') {
        dibujarBordeCompletoSinAnimar_AnuncioAovCart(wrapper.querySelector('.contenedor-status4-AnuncioAovCart'));
      }
      return;
    }
 
    if (nuevoNivel > nivelAnterior) {
      // Subiendo de nivel (se ha añadido producto al carrito)
      if (nivelAnterior === 0 && nuevoNivel >= 1) {
        irAEstado2yLuegoEstado3_AnuncioAovCart();
        if (nuevoNivel === 2) {
          // Ha saltado los dos umbrales de golpe: tras el ciclo 2→3
          // encadenamos directamente la celebración final.
          setTimeout(irAEstado4_AnuncioAovCart, DURACION_BORDE * 2 + 200);
        }
      } else if (nivelAnterior === 1 && nuevoNivel === 2) {
        irAEstado4_AnuncioAovCart();
      }
    } else {
      // Bajando de nivel (se han quitado productos del carrito)
      if (nivelAnterior === 2) {
        salirDeEstado4HaciaEstado3_AnuncioAovCart();
        if (nuevoNivel === 0) {
          setTimeout(irAEstado1_AnuncioAovCart, DURACION_BORDE + 100);
        }
      } else if (nivelAnterior === 1 && nuevoNivel === 0) {
        irAEstado1_AnuncioAovCart();
      }
    }
 
    nivelAnterior = nuevoNivel;
  }
 
  function actualizar_AnuncioAovCart() {
    const sectionId = wrapper.dataset.sectionId;
    const url = `${window.location.pathname}?section_id=${sectionId}&t=${Date.now()}`;
 
    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const nuevoWrapper = temp.querySelector('#anuncio-aov-cart_AnuncioAovCart');
 
        if (!nuevoWrapper) {
          // El carrito se ha quedado vacío (el {% if cart.item_count > 0 %}
          // del Liquid ya no imprime nada): ocultamos lo que hubiera.
          wrapper.style.display = 'none';
          return;
        }
 
        const nuevoNivel = parseInt(nuevoWrapper.dataset.nivel, 10) || 0;
        const estabaOculto = wrapper.style.display === 'none';
 
        // Actualizamos los textos/importes de los 4 bloques (aunque estén
        // ocultos) sin tocar el data-state actual, que lo gestiona la
        // máquina de estados de arriba.
        wrapper.innerHTML = nuevoWrapper.innerHTML;
        wrapper.style.removeProperty('display');
 
        if (estabaOculto) {
          // Reaparece tras haber estado vacío: se trata como una carga
          // fresca (igual que al entrar directamente en estado-4), sin
          // reproducir ninguna animación de transición de nivel. Al
          // reemplazar solo el innerHTML, el wrapper conserva el
          // data-state de ANTES de vaciarse, así que hay que fijarlo a
          // mano con el que trae la respuesta fresca.
          setEstado_AnuncioAovCart(nuevoWrapper.getAttribute('data-state'));
          nivelAnterior = nuevoNivel;
          if (nuevoNivel === 2) {
            dibujarBordeCompletoSinAnimar_AnuncioAovCart(wrapper.querySelector('.contenedor-status4-AnuncioAovCart'));
          }
          return;
        }
 
        aplicarTransicion_AnuncioAovCart(nuevoNivel);
      })
      .catch((err) => console.error('Error actualizando anuncio AOV:', err));
  }
 
  document.addEventListener('input', (e) => {
    if (e.target.closest('form#cart') || e.target.closest('cart-items') || e.target.closest('cart-drawer')) {
      setTimeout(actualizar_AnuncioAovCart, 800);
    }
  });
 
  document.addEventListener('click', (e) => {
    const esCantidad =
      e.target.closest('.quantity__button') ||
      e.target.closest("[name='plus']") ||
      e.target.closest("[name='minus']");
 
    const esEliminar =
      e.target.closest("[name='remove']") ||
      e.target.closest("a[href*='/cart/change']") ||
      e.target.closest('.cart-remove-button') ||
      e.target.closest('.mini-cart__remove') ||
      e.target.closest('.button--tertiary');
 
    if (esCantidad || esEliminar) {
      setTimeout(actualizar_AnuncioAovCart, 1000);
    }
  });
 
  document.addEventListener('cart:updated', () => {
    setTimeout(actualizar_AnuncioAovCart, 500);
  });
});